<template>
  <div style="">
    <div v-show="isSwitching" id="divSW" class="row">
      <div class="col">
        <q-list class="page">

          <q-item v-if="Switching.length==0" >
              <q-item-section>
                  {{$t("Switch.nofundincart")}}
              </q-item-section>
          </q-item>

          <div class="row ">
            <div class="col-12 q-px-md q-pt-md" v-bind:key="Switch.index" v-for="Switch in Switching">
              <q-item-section class="q-pa-none " style="">
                <div class="row q-mb-sm" >
                  
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="">
                    <div class="fieldStyle">
                      <b>{{$t("Switch.fromfund")}}</b>
                      <div>{{ Switch.FromFundName }}</div>
                  </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                    <div class="fieldStyle">
                      <b>{{$t("Switch.fundtoswitch")}}</b>
                      <div>{{ Switch.ToFundName }}</div>
                  </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" v-if="Switch.UnitsOrPercentage==='Percentage'"> 
                    <div class="fieldStyle">
                      <b>{{$t("Switch.toswitchout")}}</b>
                      <div>{{ Switch.Percentage }} %</div>
                  </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" v-if="Switch.UnitsOrPercentage==='Units'"> 
                    <div class="fieldStyle">
                      <b>{{$t("Switch.units")}}</b>
                      <div>{{ Switch.Units }}</div>
                  </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 q-pa-sm" style="" >
                    <div class="fieldStyle">
                    <b>{{$t("Switch.salescharge")}}</b>
                    <div>{{ Switch.SalesCharge }}</div>
                  </div>
                  </div>
                
                  
                </div>
                <div class="row text-right q-mb-md q-pr-sm" style="margin-top:auto;">
                  <div class="col">
                    <q-btn outline class="" label="Remove" style="color: #ff6666;" @click="RemoveSwitching(Switch.count)"/>
                  </div>
              </div>
              
              </q-item-section>
              <q-separator style="margin: 0 0.75rem; width: auto;" v-if="Switching.indexOf(Switch) + 1 != Switching.length"/>
              
                <!-- <div class="row q-px-sm">
                  <div class="col-xs-12 col-sm-12 col-md">
                    <q-input readonly v-if="Switch.UnitsOrPercentage==='Percentage'" :label='$t("Switch.toswitchout")' :value="Switch.Percentage" suffix="%" />
                    <q-input readonly v-if="Switch.UnitsOrPercentage==='Units'" :label='$t("Switch.units")' :value="Switch.Units" />
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md">
                    <q-input readonly  :label='$t("Switch.salescharge")' :value="Switch.SalesCharge" suffix="%" />
                  </div>
                </div>
                <div class="row q-px-sm">
                  <div class="col-xs-12 col-sm-12 col-md">
                    <q-input readonly :label='$t("Switch.fundtoswitch")' :value="Switch.ToFundName" />
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md">
                    <q-input readonly :label='$t("Switch.fromfund")' :value="Switch.FromFundName" />
                  </div>
                </div>
                <div class="row text-right">
                  <div class="col-xs-12 col-sm-12 col-md">
                    <q-btn flat icon="delete" color="primary" round  @click="RemoveSwitching(Switch.count)"/>
                  </div>
                </div> -->
              <!-- </div> -->
              <!-- <q-separator/> -->
        
                </div>
            </div>
        </q-list>
      </div>
      </div>
    <!--Popup Edit Topup/New Modal-->
    <q-dialog persistent v-model="TopupModal" transition-show="rotate" transition-hide="rotate">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-center">Edit Top Up</div>
        </q-card-section>

        <q-card-section>
          <FTB></FTB>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn label="Cancel" v-close-popup />
          <q-btn label="Complete" color="primary" @click="EditCart('Buy')" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!--Popup Redeem / Switch Modal-->
    <q-dialog persistent v-model="SellModal" transition-show="rotate" transition-hide="rotate">
      <q-card>
        <q-card-section>
          <div class="text-h6 text-center">Edit Redemption/Switching</div>
        </q-card-section>

        <q-card-section>
          <!--<FTS></FTS>-->
        </q-card-section>

        <q-card-actions align="right">
          <q-btn label="Cancel" v-close-popup />
          <q-btn label="Complete" color="primary" @click="AddtoCart('Sell')" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<style>
@media screen and (min-width: 600px) {
  .fieldStyle{
    border: 1px solid #e0e0e0; border-radius: 0.5rem; padding: 8px 12px; height: 100%;
  }
}
</style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
//import FTB from "./FundTransactionBuy";
//import FTBNew from "./FundTransactionNewFund";
//import FTS from "./FundTransactionRedemption";
//import FTSprs from "./FundTransactionRedemptionPRS";
import FTSW from "./FundTransactionSwitching";
//import FIInfo from './FundInvestmentInfo';
import CB from "@/components/CartButtons";
//import BR from "@/components/BasisRecommendation";
import store from '../store';
export default {
  name: "ShoppingCart",
  components: {
    //FTB,
    //FTBNew,
    //FTS,
    //FTSprs,
    FTSW,
    //FIInfo,
    CB,
    //BR
  },
  data() {
    return {
      TopupModal: false,
      SellModal: false,
      StoreStateCD : store.state.CD,
      StoreStateT : store.state.Transactions,
      StoreStateLookup : store.state.Lookup,
      StoreStateLogin: store.state.Login,
    }
  },
  computed: {
    ...mapState({
      Investment: state => state.CD.Transaction.Investment,
      Redemption: state => state.CD.Transaction.Redemption,
      Switching: state => state.CD.Transaction.Switching
    }),
    ...mapGetters([
      "isInvestment",
      "isRedemption",
      "isSwitching"
    ]),
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      "Delete_Investment",
      "Delete_Redemption",
      "Delete_Switching",
      "PostTransaction"
    ]),
    TopupFund() {
      this.TopupModal = true;
    },
    SellFund() {
      this.SellModal = true;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    AddtoCart(Tr) {
      // do something, add to cart
      var Trans = Tr;
      if (Trans === "Buy") {
        this.TopupModal = false;
      } else if (Trans === "Sell") {
        this.SellModal = false;
      }
    },
    RemoveInvestment(Id){
      this.Delete_Investment(Id)
    },
    RemoveRedemption(Id){
      this.Delete_Redemption(Id)
    },
    RemoveSwitching(count){
      //this.Delete_Switching(count)

      if(this.StoreStateCD.Transaction.Switching.length>0){
          this.$q.loading.show({
              spinnerSize: 50
          })

        for(var j=0; j<this.StoreStateCD.Transaction.Switching.length; j++){
          if(this.StoreStateCD.Transaction.Switching[j].count === count ){
            this.StoreStateCD.Transaction.Switching.splice(j,1)
          }
        }        

        this.PostTransaction({
          ApplicationId : this.StoreStateCD.FormDetails.ApplicationId
        })
        .then(res=>{

        this.$store.dispatch('Logging',
        {
            typeid :'4', 
            appid : '2',
            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'PostTransaction (switch)-> ' + this.StoreStateCD.FormDetails.ApplicationId + '. res --> ' + res
        });
            if(res!=true){
                this.$q.loading.hide()
                this.$q.dialog({
                    title: 'Error',
                    message:  res ,
                })    
            }
            else{
              this.$q.loading.hide()
            }
        })        
      }  
    }
  }
};
</script> 